export var AddProductErrorCode;
(function (AddProductErrorCode) {
    AddProductErrorCode["PRODUCT_EXISTS_IN_SUBSCRIPTION"] = "4";
})(AddProductErrorCode || (AddProductErrorCode = {}));
//# sourceMappingURL=errorCodes.js.map